export default __webpack_public_path__ + "static/media/approved.d000ad39.svg";